import { EntityGoal } from "../../entity/EntityGoal";

export class DtoGoalsDeleteRes extends EntityGoal {
  public message: string | null = null;
}
